<div class="menu">
	<div class="icon" (click)="toggleMenu(true)">{{ expand ? 'close' : 'menu' }}</div>
</div>
<div class="items" [ngClass]="{ expand: expand }">
	<ng-container *ngFor="let item of navItems">
		<div class="item" [ngClass]="{ active: activeItem && item.title === activeItem.title, expand: expand }">
			<div class="icon" [title]="item.title" [ngClass]="{ active: activeItem && item.title === activeItem.title }" (click)="navigateTo(item)">
				<ng-container *ngIf="item.icon.includes('.svg') || item.icon.includes('.png'); else materialIcon">
					<img [src]="'assets/images/' + item.icon" alt="{{ item.title }}" class="nav-icon" />
				</ng-container>
				<ng-template #materialIcon>
					<span class="material-symbols-outlined">{{ item.icon }}</span>
				</ng-template>
			</div>			
			<div class="title" [ngClass]="{ active: activeItem && item.title === activeItem.title, expand: expand }" (click)="navigateTo(item)">{{ item.title }}</div>

			<ng-container *ngFor="let subItem of navSubItems">
				<div class="sub" [ngClass]="{ expand: expand }" *ngIf="subItem.parent === item.title">
					<div class="arrow" [ngClass]="{ active: activeItem && subItem.title === activeItem.title }">►</div>
					<div class="line"></div>
					<div class="icon" [ngClass]="{ active: activeItem && subItem.title === activeItem.title }" 
					[title]="subItem.title" 
					(click)="navigateTo(subItem)">
				
					<ng-container *ngIf="subItem.icon.includes('.svg') || subItem.icon.includes('.png'); else subMaterialIcon">
						<img [src]="'assets/images/' + subItem.icon" alt="{{ subItem.title }}" class="nav-icon" />
					</ng-container>
					
					<ng-template #subMaterialIcon>
						<span class="material-symbols-outlined">{{ subItem.icon }}</span>
					</ng-template>
				</div>
					<div class="title" [ngClass]="{ active: activeItem && subItem.title === activeItem.title }" (click)="navigateTo(subItem)">{{ subItem.title }}</div>
				</div>
			</ng-container>
		</div>
	</ng-container>

	<div class="toggle" [ngClass]="{ expand: expand }">
		<div [title]="appTitle" class="icon" (click)="toggleFullscreen()">{{ appIcon }}</div>
		<br />
		<div class="icon" (click)="toggleMenu()">{{ expand ? 'keyboard_double_arrow_left' : 'keyboard_double_arrow_right' }}</div>
	</div>
</div>


<footer [ngClass]="{ expand: expand }"></footer>
